import { render, staticRenderFns } from "./RateCard.vue?vue&type=template&id=6727c5e8&"
import script from "./RateCard.vue?vue&type=script&lang=js&"
export * from "./RateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports